import { useEffect } from "react";
import { EditorContent, JSONContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Image from "@tiptap/extension-image";
import Link from "@tiptap/extension-link";
import { MorrocarsCallout, MorrocarsCta } from "./morrocarsBlocks";

export function BlogRenderer({ content }: { content: JSONContent }) {
  const editor = useEditor({
    extensions: [StarterKit, Link.configure({ openOnClick: true }), Image, MorrocarsCallout, MorrocarsCta],
    content,
    editable: false,
    editorProps: { attributes: { class: "blog-article prose max-w-none text-[#4B5563] leading-relaxed outline-none" } },
  });
  useEffect(() => { if (editor) editor.commands.setContent(content); }, [editor, content]);
  return editor ? <EditorContent editor={editor} /> : null;
}
